import { c as _c } from "react/compiler-runtime";
import { getTranslations } from 'next-intl/server';
import { SettingsIcon, WrenchIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { BrandLogo, SocialMediaLinks } from '@/components/partials';
import { LocalizedMetaData } from '@/lib/utils.server';
type PropsType = {
  meta: LocalizedMetaData;
};
const MaintenancePage = async t0 => {
  const $ = _c(37);
  const {
    meta
  } = t0;
  let t1;
  let t10;
  let t11;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== meta) {
    const t = await getTranslations();
    const {
      socialMediaLinks,
      generalSettings
    } = meta;
    t8 = "from-background via-muted/10 to-background relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-linear-to-br p-4 select-none";
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <div className="bg-primary/5 absolute top-[-10%] left-[-10%] h-72 w-72 rounded-full blur-3xl" />;
      t10 = <div className="bg-primary/5 absolute right-[-10%] bottom-[-10%] h-96 w-96 rounded-full blur-3xl" />;
      $[12] = t10;
      $[13] = t9;
    } else {
      t10 = $[12];
      t9 = $[13];
    }
    let t12;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <div className="mx-auto mb-2 flex w-48 justify-center"><BrandLogo /></div>;
      $[14] = t12;
    } else {
      t12 = $[14];
    }
    let t13;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <div className="bg-primary/10 border-primary/20 group relative mx-auto flex h-28 w-28 items-center justify-center rounded-full border shadow-inner"><WrenchIcon className="text-primary h-12 w-12 animate-pulse transition-transform duration-300 group-hover:rotate-12" /><SettingsIcon className="text-primary/60 absolute top-4 right-4 h-6 w-6 animate-[spin_10s_linear_infinite]" /></div>;
      $[15] = t13;
    } else {
      t13 = $[15];
    }
    const t14 = <div className="space-y-3"><h1 className="from-foreground to-foreground/80 bg-linear-to-r bg-clip-text text-3xl font-bold tracking-tight sm:text-4xl">{t("under_maintenance")}</h1><p className="text-muted-foreground mx-auto max-w-sm text-sm leading-relaxed sm:text-base">{t("maintenance_description")}</p></div>;
    let t15;
    if ($[16] !== generalSettings) {
      t15 = (generalSettings?.email || generalSettings?.phone) && <div className="pt-2"><div className="text-muted-foreground bg-muted/40 inline-flex flex-col items-center justify-center gap-x-6 gap-y-2 rounded-full border px-4 py-2.5 text-xs sm:flex-row">{generalSettings?.email && <a href={`mailto:${generalSettings.email}`} className="hover:text-primary flex items-center gap-1.5 transition-colors"><MailIcon className="h-3.5 w-3.5" /><span>{generalSettings.email}</span></a>}{generalSettings?.phone && <a href={`tel:${generalSettings.phone}`} className="hover:text-primary flex items-center gap-1.5 transition-colors"><PhoneIcon className="h-3.5 w-3.5" /><span>{generalSettings.phone}</span></a>}</div></div>;
      $[16] = generalSettings;
      $[17] = t15;
    } else {
      t15 = $[17];
    }
    const t16 = socialMediaLinks && socialMediaLinks.length > 0 && <div className="space-y-3 border-t pt-4"><span className="text-muted-foreground/60 block text-xs font-semibold tracking-wider uppercase">{t("follow_us")}</span><div className="flex justify-center"><SocialMediaLinks links={socialMediaLinks} /></div></div>;
    if ($[18] !== t14 || $[19] !== t15 || $[20] !== t16) {
      t11 = <div className="bg-card/60 animate-in fade-in slide-in-from-bottom-4 relative z-10 w-full max-w-lg space-y-8 rounded-3xl border p-8 text-center shadow-2xl backdrop-blur-md duration-500 md:p-12">{t12}{t13}{t14}{t15}{t16}</div>;
      $[18] = t14;
      $[19] = t15;
      $[20] = t16;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    t1 = "text-muted-foreground/60 z-10 mt-8 text-xs";
    t2 = "\xA9 ";
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = new Date().getFullYear();
      $[22] = t3;
    } else {
      t3 = $[22];
    }
    t4 = " ";
    t5 = meta.appTitle;
    t6 = ". ";
    t7 = t("all_rights_reserved");
    $[0] = meta;
    $[1] = t1;
    $[2] = t10;
    $[3] = t11;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t1 = $[1];
    t10 = $[2];
    t11 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
    t8 = $[10];
    t9 = $[11];
  }
  let t12;
  if ($[23] !== t1 || $[24] !== t2 || $[25] !== t3 || $[26] !== t4 || $[27] !== t5 || $[28] !== t6 || $[29] !== t7) {
    t12 = <p className={t1}>{t2}{t3}{t4}{t5}{t6}{t7}</p>;
    $[23] = t1;
    $[24] = t2;
    $[25] = t3;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
    $[29] = t7;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t10 || $[32] !== t11 || $[33] !== t12 || $[34] !== t8 || $[35] !== t9) {
    t13 = <div className={t8}>{t9}{t10}{t11}{t12}</div>;
    $[31] = t10;
    $[32] = t11;
    $[33] = t12;
    $[34] = t8;
    $[35] = t9;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  return t13;
};
export default MaintenancePage;